/**
 * Web mock for react-native-calendar-events
 * Native module doesn't work on web, so we provide a web-compatible mock
 */

// Mock implementation for web platform
const RNCalendarEvents = {
  requestPermissions: async () => {
    console.warn('Calendar permissions not available on web');
    return { status: 'undetermined' };
  },
  
  checkPermissions: async () => {
    return 'undetermined';
  },
  
  findCalendars: async () => {
    console.warn('Calendar access not available on web');
    return [];
  },
  
  saveEvent: async (title, details) => {
    console.warn('Saving calendar events not available on web. Use browser calendar links instead.');
    // Fallback: Open calendar link
    const startDate = details.startDate || new Date().toISOString();
    const endDate = details.endDate || new Date(Date.now() + 3600000).toISOString();
    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${startDate.replace(/[-:]/g, '').split('.')[0]}Z/${endDate.replace(/[-:]/g, '').split('.')[0]}Z`;
    if (typeof window !== 'undefined') {
      window.open(calendarUrl, '_blank');
    }
    return null;
  },
  
  findEventById: async (id) => {
    return null;
  },
  
  removeEvent: async (id, options) => {
    console.warn('Removing calendar events not available on web');
    return null;
  },
  
  removeFutureEvents: async (id, options) => {
    console.warn('Removing future calendar events not available on web');
    return null;
  },
};

export default RNCalendarEvents;


